<div class="fee">
  <span class="subheader secondary"> {{ labelText | translate }}: </span>
  <span class="subheader primary" data-qa="additional-fee">
    {{ totalFee | cropNumber : account.decimals }} {{ account.asset }}
    <ng-container *ngIf="totalFee > 0 && isShowFeeInRefCurrency">({{ currencySign }}{{ feeInRefCurrency | numberFr }})</ng-container>
  </span>
</div>
